import axios from 'axios';

const VITE_API_PATH = import.meta.env.VITE_API_PATH ?? 'access.wicketsoft.com';
const VITE_LOCAL_API_PATH = import.meta.env.VITE_LOCAL_API_PATH ?? 'localhost:5555';
const IS_LOCAL = import.meta.env.VITE_IS_LOCAL_API === 'true';

const createAxiosInstance = (api: 'api' | 'api-reporting') => {
  const createBaseURL = () => {
    if (IS_LOCAL) {
      return `http://${VITE_LOCAL_API_PATH}`;
    }
    return `${location.protocol}//${VITE_API_PATH}/${api}`;
  };

  return axios.create({
    baseURL: createBaseURL(),
    headers: {
      'Content-Type': 'application/json',
      Apiversion: '1.9',
      Appplatform: 'web',
    },
  });
};

const axiosInstance = createAxiosInstance('api');
const axiosReportingInstance = createAxiosInstance('api-reporting');

export { axiosInstance, axiosReportingInstance };
